export const getDealStatusTrackingValue = ({ dealStatus, additionalValue = '' }) =>
  dealStatus ? `-${dealStatus.toLowerCase().replace(' ', '-')}${additionalValue}` : '';
